// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatInspectResponse" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { CrisisBannerGenShape } from "./crisis-banner.gen";
import { ClarifierPickerPromptGenShape } from "./clarifier-picker-prompt.gen";
import { TenurePickerPromptGenShape } from "./tenure-picker-prompt.gen";
import { ExtractedSituationGenShape } from "./extracted-situation.gen";
import { InspectIssueGroupGenShape } from "./inspect-issue-group.gen";
import { ChatWorkflowScoringConfigGenShape } from "./chat-workflow-scoring-config.gen";
import { InspectJudgeDivergenceGenShape } from "./inspect-judge-divergence.gen";
import { InspectNarrativeStepGenShape } from "./inspect-narrative-step.gen";
import { InspectSkillRunGenShape } from "./inspect-skill-run.gen";
import { InspectSkillErrorGenShape } from "./inspect-skill-error.gen";
import { RouteMatchGenShape } from "./route-match.gen";
import { SuppressedMatchGenShape } from "./suppressed-match.gen";
import { ChatRoutingUsageGenShape } from "./chat-routing-usage.gen";
import { ChatRoutingTimingsGenShape } from "./chat-routing-timings.gen";
import { ChatRoutingOutcome } from "./chat-routing-outcome.enum.gen";
import { InspectSkillRawCallGenShape } from "./inspect-skill-raw-call.gen";
import { ChatRoutingLogVersionsGenShape } from "./chat-routing-log-versions.gen";
import { ChatRouteStateGenShape } from "./chat-route-state.gen";

export const ChatInspectResponseGenShape = z.strictObject({
  redactedInput: z.string(),
  redactedCategories: z.array(z.string()),
  crisis: z.array(CrisisBannerGenShape),
  detectedCrisisFlags: z.array(z.string()),
  halted: z.boolean(),
  clarifyingQuestion: z.string().optional(),
  clarifierPicker: ClarifierPickerPromptGenShape.optional(),
  tenurePicker: TenurePickerPromptGenShape.optional(),
  situation: ExtractedSituationGenShape.optional(),
  issueGroups: z.array(InspectIssueGroupGenShape),
  catalogueCount: z.number(),
  tenureFilteredCount: z.number(),
  shortlistedCount: z.number(),
  scoringConfig: ChatWorkflowScoringConfigGenShape.optional(),
  judge: InspectJudgeDivergenceGenShape.optional(),
  narrative: z.array(InspectNarrativeStepGenShape),
  skillRuns: z.array(InspectSkillRunGenShape),
  decidingStage: z.string().optional(),
  lever: z.string().optional(),
  skillErrors: z.array(InspectSkillErrorGenShape),
  matches: z.array(RouteMatchGenShape),
  suppressedMatches: z.array(SuppressedMatchGenShape),
  coverageGaps: z.array(z.string()),
  usage: ChatRoutingUsageGenShape.optional(),
  timings: ChatRoutingTimingsGenShape.optional(),
  outcome: z.enum(ChatRoutingOutcome),
  errorClass: z.string().optional(),
  traceId: z.string(),
  engineMajor: z.number(),
  rawCalls: z.array(InspectSkillRawCallGenShape),
  versions: ChatRoutingLogVersionsGenShape,
  state: ChatRouteStateGenShape,
});
